export default "__VITE_ASSET__CZJqJE1L__"